import styled from '@emotion/styled';

import { Breakpoints } from '../../../../styles/variables/breakpoints';

const { sm } = Breakpoints;

export const StyledChatBarNew = styled.div`
    box-sizing: border-box;
    padding-top: 12px;
    height: 100%;
    width: 324px;

    @media (min-width: ${sm}) {
        border-right: 1px solid #f5f5f5;
    }
`;

export const StyledChatBarSearch = styled.div`
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    justify-content: flex-start;
    box-sizing: border-box;
    margin: 0 12px 24px;
    align-items: center;
    background: #fcfaff;
    border-radius: 4px;
    display: flex;
    height: 41px;

    #SearchIcon {
        margin: 8px;
    }
`;

export const StyledChatBarInput = styled.input`
    background: #fcfaff;
    color: #686868;
    flex-grow: 1;

    &:hover,
    &:active,
    &:focus {
        outline: none;
    }
`;

export const StyledChatBarItemsContainer = styled.div`
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 0 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center; // Add this line to center the content horizontally
`;

export const StyledChatBarItems = styled.div`
    height: 100%;
    width: 100%;
`;
